import {
    deviceManufacturerFulfilledConstants,
    deviceManufacturerPendingConstants,
    deviceManufacturerRejectedConstants
} from '../actions/deviceManufacturer';

const initialState = {
    data: [],
    error: '',
    loading: true
};

export default function (state = initialState, action) {
    switch (action.type) {
        case deviceManufacturerPendingConstants.DEVICE_MANUFACTURER_LOADED:
            return initialState;
        case deviceManufacturerFulfilledConstants.DEVICE_MANUFACTURER_LOADED:
            return {
                ...initialState,
                data: [].concat(action.payload).sort((a, b) => {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;
                    return 0;
                }),
                loading: false
            };
        case deviceManufacturerFulfilledConstants.DEVICE_MANUFACTURER_CREATED:
            return { ...initialState,
                loading: false,
                data: [...state.data, action.payload] };
        case deviceManufacturerFulfilledConstants.DEVICE_MANUFACTURER_UPDATED:
            return { ...state,
                loading: false,
                data: state.data.map(c => (c.id === action.payload.id ? action.payload : c)) };
        case deviceManufacturerPendingConstants.DEVICE_MANUFACTURER_CREATED:
        case deviceManufacturerPendingConstants.DEVICE_MANUFACTURER_UPDATED:
            return { ...state, loading: true };
        case deviceManufacturerFulfilledConstants.DEVICE_MANUFACTURER_DELETED:
            return { ...state, data: state.data.filter(c => c.id !== action.payload) };
        case deviceManufacturerRejectedConstants.DEVICE_MANUFACTURER_CREATED:
        case deviceManufacturerRejectedConstants.DEVICE_MANUFACTURER_UPDATED:
        case deviceManufacturerRejectedConstants.DEVICE_MANUFACTURER_DELETED: {
            const error = action.payload;

            if (error.response) {
                return {
                    ...state,
                    loading: false,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                return {
                    ...state,
                    loading: false,
                    error: error.message
                };
            }

            return state;
        }
        default:
            return state;
    }
}
